import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEOHead = ({ 
  title = "Time2Find - Enterprise IT Solutions & Digital Transformation",
  description = "Leading Enterprise IT Solutions provider specializing in SAP Implementation, Cloud Solutions, Cybersecurity, Data Analytics, IoT Solutions, and Quality Assurance. Transform your business with our expert consulting services.",
  keywords = "SAP Implementation, Cloud Solutions, Cybersecurity, Data Analytics, IoT Solutions, Quality Assurance, Enterprise IT, Business Transformation, Digital Solutions, IT Consulting, Time2Find",
  canonical = "https://time2find.com/",
  ogTitle,
  ogDescription,
  ogImage = "/images/hero/main-logo.png",
  schemaType = "WebPage"
}) => {
  const finalOgTitle = ogTitle || title;
  const finalOgDescription = ogDescription || description;
  
  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonical} />
      
      {/* Open Graph Meta Tags */}
      <meta property="og:title" content={finalOgTitle} />
      <meta property="og:description" content={finalOgDescription} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />
      
      {/* Twitter Card Meta Tags */}
      <meta name="twitter:title" content={finalOgTitle} />
      <meta name="twitter:description" content={finalOgDescription} />
      <meta name="twitter:image" content={ogImage} />
      
      {/* Schema.org Structured Data for individual pages */}
      {schemaType === "AboutPage" && (
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "AboutPage",
            "name": title,
            "description": description,
            "url": canonical,
            "mainEntity": {
              "@type": "Organization",
              "name": "Time2Find",
              "description": "Enterprise IT Solutions provider with expertise in digital transformation"
            }
          })}
        </script>
      )}
      
      {schemaType === "ContactPage" && (
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ContactPage",
            "name": title,
            "description": description,
            "url": canonical
          })}
        </script>
      )}
      
      {schemaType === "Service" && (
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            "name": title,
            "description": description,
            "url": canonical,
            "provider": {
              "@type": "Organization",
              "name": "Time2Find"
            }
          })}
        </script>
      )}
    </Helmet>
  );
};

export default SEOHead;